(function (angular) {
    "use strict";
    angular.module('smartpublic.core')
        .controller('ComplaintsformController', ComplaintsformController);

    ComplaintsformController.$inject = ['$log', 'ComplaintsformFactory', '$scope', '$state', 'vcRecaptchaService'];

    function ComplaintsformController($log, ComplaintsformFactory, $scope, $state, vcRecaptchaService) {
        $log.debug('Running ComplaintsformController');
        var vm = this;

        vm.submitComplaint = submitComplaint;
        vm.deleteFile = deleteFile; 
        vm.clearForm = clearForm;
        vm.submitInfoRequest = submitInfoRequest;
        vm.dismissEmailConfirmationMessage = dismissEmailConfirmationMessage;

        vm.setInfoRecaptchaId = setInfoRecaptchaId;
        vm.setComplaintRecaptchaId = setComplaintRecaptchaId;

        vm.reloadRecaptcha = reloadRecaptcha;
        vm.downloadFile = downloadFile;
        vm.upload = upload;

        vm.data = {};
        vm.data.complaint = {};
        vm.data.complaint.attachments = [];
        vm.data.infoRequest = {};
        vm.formSuccess = false;
        vm.formError = false;
        vm.infoRecaptchaId = null;
        vm.complaintRecaptchaId = null;

        vm.loading = false;
        
        vm.infoFormHasError = false;
        vm.complaintFormHasError = false;

        function clearForm() {
            vm.data = {};
            vm.data.complaint = {};
            vm.data.complaint.attachments = [];
            vm.data.infoRequest = {};

            vm.infoForm.$setPristine();
            vm.infoForm.$setUntouched();
            vm.infoFormHasError = false;
            
            
            vm.complaintForm.$setPristine();
            vm.complaintForm.$setUntouched();
            vm.complaintFormHasError = false;

            vm.loading = false;

            //reloadRecaptcha();
        }
        
        vm.changeForm = changeForm;
        function changeForm() {
            vm.formSuccess = false;
            vm.formError = false;
        	clearForm();
        }

        function submitComplaint(form) {
        	
        	dismissEmailConfirmationMessage();
        	
        	if(form.$invalid){
        		vm.complaintFormHasError = true;
        		return;
        	} 

        	vm.complaintFormHasError = false;
            vm.loading = true;

            ComplaintsformFactory.submitComplaint(vm.data.complaint).then(
                function (resp) {
                    vm.formSuccess = true;
                    clearForm();
                },

                function (error) {
                    vm.formError = true;
                    vm.loading = false;
                    reloadRecaptcha();
                }
            );
        }


        function submitInfoRequest(form) {
        	
        	dismissEmailConfirmationMessage();
        	
        	if(form.$invalid){
        		vm.infoFormHasError = true;
        		return;
        	} 

        	vm.infoFormHasError = false;
            vm.loading = true;
            
            switch (vm.motive) {
                case '1':
                    vm.data.infoRequest.subject = 'Esclarecimentos sobre o Plano Montepio Saúde';
                    break;
                case '2':
                    vm.data.infoRequest.subject = 'Informação sobre a Rede de Saúde Montepio';
                    break;
                case '3':
                    vm.data.infoRequest.subject = 'Reclamações sobre a Rede de Saúde Montepio';
                    break;
                case '4':
                    vm.data.infoRequest.subject = 'Sugestões/Reclamações sobre os Serviços ao Domicílio';
                    break;
                case '5':
                    vm.data.infoRequest.subject = 'Esclarecimentos sobre a sua condição de Associado Montepio';
                    break;
                default :
                    vm.data.infoRequest.subject = 'Esclarecimentos sobre o Plano Montepio Saúde';
            }

            ComplaintsformFactory.submitInfoRequest(vm.data.infoRequest).then(
                function (resp) {
                    vm.formSuccess = true;
                    clearForm();
                },
                function (error) {
                    vm.formError = true;
                    vm.loading = false;
                    reloadRecaptcha();
                }
            );
        }

        function deleteFile(fileIndex, $event) {
            $event.preventDefault();
            if (vm.data.complaint.attachments.length > 0) {
                vm.data.complaint.attachments.splice(fileIndex, 1);
            }
        }

        function dismissEmailConfirmationMessage() {
            vm.formSuccess = false;
            vm.formError = false;
        }

        function setInfoRecaptchaId(recaptchaId) {
            vm.infoRecaptchaId = recaptchaId;
        }

        function setComplaintRecaptchaId(recaptchaId) {
            vm.complaintRecaptchaId = recaptchaId;
        }

        function reloadRecaptcha() {

            if (vm.infoRecaptchaId !== null) {
                vcRecaptchaService.reload(vm.infoRecaptchaId);
            }
            if (vm.complaintRecaptchaId !== null) {
                vcRecaptchaService.reload(vm.complaintRecaptchaId);
            }
        }

        function downloadFile(filename) {
            ComplaintsformFactory.downloadFileRequest(filename).then(
                function (resp) {
                    vm.formSuccess = true;
                    clearForm();
                },
                function (error) {
                    vm.formError = true;
                    reloadRecaptcha();
                }
            );
        }

        function upload($event) {
            $event.stopPropagation();
            $event.preventDefault();
            angular.element('#dropZoneUpload').trigger('click');
        }


    }

})(angular);